<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">

    <!-- Título e botões de topo -->
    <div class="row mb-4 header-row">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Tipos Tributários</h1>
            <p class="welcome-message">
              <button mat-icon-button type="button" (click)="voltar()" aria-label="Voltar">
                <mat-icon>arrow_back</mat-icon>
              </button>
              Gerenciamento dos tipos tributários
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
          @if (selection.hasValue()) {
          <span>Ações ({{ selection.selected.length }})</span>
          } @else {
          <span>Ações</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #opcoesMenu="matMenu">
          <!-- O tooltip fica no wrapper porque elementos desabilitados não disparam eventos
               de mouse; mesmo padrão usado no cadastro da Tabela DIFAL. -->
          <span [matTooltip]="getExcluirTooltip()" [matTooltipDisabled]="selection.hasValue()">
            <button mat-menu-item (click)="excluirSelecionados()" [disabled]="!selection.hasValue()">
              <mat-icon class="material-symbols-outlined">delete</mat-icon>
              <span>Excluir selecionados</span>
            </button>
          </span>
        </mat-menu>
        <button mat-flat-button class="btn-primary" (click)="novoTipoTributario()">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
          Novo Tipo Tributário
        </button>
      </div>
    </div>

    <!-- Pesquisa -->
    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" formControlName="pesquisa" placeholder="Pesquisar por código ou descrição" />
            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
    </form>

    @if (_isLoading && _dataSource.data.length === 0) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (_dataSource.data.length > 0) {

    <!-- Tabela desktop -->
    <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort matSortActive="codigo"
      matSortDirection="asc">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="w-checkbox">
          <mat-checkbox (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="w-checkbox">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="codigo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
        <td mat-cell *matCellDef="let row" class="col-codigo"><strong>{{ row.codigo }}</strong></td>
      </ng-container>

      <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
        <td mat-cell *matCellDef="let row">{{ row.descricao }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="text-center">Status</th>
        <td mat-cell *matCellDef="let row" class="text-center">
          <span class="status-badge" [class.badge-verde]="row.isAtivo" [class.badge-cinza]="!row.isAtivo">
            {{ row.isAtivo ? 'Ativo' : 'Inativo' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
        <td mat-cell *matCellDef="let row" class="text-center w-actions">
          <button mat-icon-button [matMenuTriggerFor]="menuAcoes" aria-label="Ações">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menuAcoes="matMenu">
            <button mat-menu-item (click)="editarTipoTributario(row.idTipoTributario)">
              <span class="material-symbols-outlined">edit</span>
              <span>Editar</span>
            </button>
            <button mat-menu-item (click)="excluir(row)">
              <span class="material-symbols-outlined">delete</span>
              <span>Excluir</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <!-- Cards mobile -->
    <div class="mobile-view">
      @for (item of _dataSource.data; track item.idTipoTributario) {
      <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
        <div class="card-header-mobile d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-2">
            <mat-checkbox (change)="$event ? selection.toggle(item) : null" [checked]="selection.isSelected(item)">
            </mat-checkbox>
            <span class="text-bold">{{ item.codigo }}</span>
          </div>
          <button mat-icon-button [matMenuTriggerFor]="menuMob">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menuMob="matMenu">
            <button mat-menu-item (click)="editarTipoTributario(item.idTipoTributario)">Editar</button>
            <button mat-menu-item (click)="excluir(item)">Excluir</button>
          </mat-menu>
        </div>
        <div class="card-body-mobile p-3">
          <p class="mb-1">{{ item.descricao }}</p>
          <p class="mb-0">
            <strong>Status:</strong>
            <span class="status-badge ms-1" [class.badge-verde]="item.isAtivo" [class.badge-cinza]="!item.isAtivo">
              {{ item.isAtivo ? 'Ativo' : 'Inativo' }}
            </span>
          </p>
        </div>
      </div>
      }
    </div>

    <div class="col-12 text-center mt-4 mb-5">
      <button mat-button class="btn-ver-mais" [disabled]="_isLoading || _dataSource.data.length >= _totalRegistros"
        (click)="proximaPagina()">
        @if (_isLoading) {
        <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
        <span class="material-symbols-outlined">expand_more</span>
        Ver Mais
        }
      </button>
    </div>

    } @else {
    <app-empty-list [title]="'Nenhum tipo tributário encontrado.'"
      [subTitle]="'Tente alterar a busca ou adicione um novo registro.'"></app-empty-list>
    }

  </div>
</div>
